import React from "react";
import { Outlet } from "react-router-dom";
import Header from './header'
import Footer from "./footer";
const Master = () => {
  return (
    <>
      <div className="main-layout">
          <Header/>
          <div className="all-router-data">
            <Outlet />
          </div>
          <Footer/>
      </div>
    </>
  );
};

export default Master;
